<div>
    <slot />
</div>

<style>
    div {
        @apply flex;
        @apply h-12 w-full;
        @apply fixed bottom-0;
    }
</style>
